import type { SubletListPriceDiscountInfo } from '../types/invoice';
import { SUBLET_PRICING_WILDCARD } from './subletPricingConstants';

function formatDiscountPercent(discountPercentage: number): string {
    const whole = Math.round(discountPercentage * 1000) / 10;
    return Number.isInteger(whole) ? `${whole}%` : `${whole}%`;
}

function formatResolvedKeys(discount: SubletListPriceDiscountInfo): string | null {
    const parts: string[] = [];
    if (discount.insuranceCompanyName) {
        parts.push(`insurance: ${discount.insuranceCompanyName}`);
    } else if (discount.insuranceCompanyId && discount.insuranceCompanyId !== SUBLET_PRICING_WILDCARD) {
        parts.push('insurance: (unresolved name)');
    }
    if (discount.supplierName) {
        parts.push(`vendor: ${discount.supplierName}`);
    } else if (discount.supplierId && discount.supplierId !== SUBLET_PRICING_WILDCARD) {
        parts.push('vendor: (unresolved name)');
    }
    if (discount.state) {
        const stateLabel = discount.state === SUBLET_PRICING_WILDCARD ? 'All' : discount.state;
        parts.push(`state: ${stateLabel} (shop location)`);
    }
    return parts.length > 0 ? parts.join(' · ') : null;
}

/** Multi-line tooltip explaining sublet buy-price discount for the invoice detail table. */
export function formatSubletListPriceDiscountTooltip(
    discount: SubletListPriceDiscountInfo | null | undefined,
): string {
    const percentLabel = formatDiscountPercent(discount?.discountPercentage ?? 0);
    const resolvedKeys = discount ? formatResolvedKeys(discount) : null;
    const lines = [
        'List price = extracted invoice rate',
        'Buy price = List price × (1 − discount)',
        '',
        `Discount applied: ${percentLabel}`,
    ];

    if (!discount) {
        lines.push('', 'Discount details are not available for this invoice yet.');
        return lines.join('\n');
    }

    lines.push('Source: Parts-specific and sublet-specific discounts (insurance + vendor + state).');
    if (resolvedKeys) {
        lines.push(`Matched: ${resolvedKeys}`);
    }
    return lines.join('\n');
}
